import type { EnumUnion } from '@dresscode-frontend/utility-types';

// Public IDs のカテゴリフィルターキー（list contract の category に対応。ALL は絞り込みなし）
export const PublicIdCategoryFilterKey = {
  NATIONAL_ID: 'NATIONAL_ID',
  TRAVEL_DOCUMENT: 'TRAVEL_DOCUMENT',
  ALL: 'ALL'
} as const;
export type PublicIdCategoryFilterKey = EnumUnion<typeof PublicIdCategoryFilterKey>;

// 国民 ID の subtype（NationalIdSubtype）は feature 共有の `-shared/publicId` を唯一の定義元とする。

// Public IDs テーブルの列定義（nationalIdType は subtype を流用した表示列）
export const Columns = {
  NATIONAL_ID_TYPE: 'nationalIdType',
  PERSON: 'person',
  ISSUE_DATE: 'issueDate',
  EXPIRY_DATE: 'expiryDate'
} as const;